// removed by extract-text-webpack-plugin
module.exports = {"modal":"ModalMonitoringEvent--modal--2iv9DzPB","row":"ModalMonitoringEvent--row--3bP0ylKq","borderBottom":"ModalMonitoringEvent--borderBottom--14blSgbg","infoBlock":"ModalMonitoringEvent--infoBlock--22sarFSf","info":"ModalMonitoringEvent--info--3LFFSYr3","active":"ModalMonitoringEvent--active--27hf2dEZ","inactive":"ModalMonitoringEvent--inactive--3tl6pQlm","signalsContainer":"ModalMonitoringEvent--signalsContainer--2CLKl7Ho","signalsContent":"ModalMonitoringEvent--signalsContent--3wG7lGnP"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/modal/ModalMonitoringEvent/ModalMonitoringEvent.scss
// module id = 895
// module chunks = 0